import {
  GET_ALL_OPERADORES,
  GET_SPECIFIC_OPERADOR,
  GET_ALL_QUEUES,
  GET_ALL_ROUTES,
  GET_ALL_DEPARTAMENTOS,
  GET_OPERADORES_MONITOR,
  LISTAR_GRUPOS_DE_ROTAS
} from './mutation-types'
import operadorHttpService from '../_services/operadorHttpService'

export default {
  listarOperadores: async ({ commit }) => {
    try {
      const response = await operadorHttpService.getOperadores()
      commit(GET_ALL_OPERADORES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarOperadorEspecifico: async ({ commit }, id) => {
    try {
      const response = await operadorHttpService.getOperador(id)
      commit(GET_SPECIFIC_OPERADOR, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarFilas: async ({ commit }) => {
    try {
      const response = await operadorHttpService.getFilas()
      commit(GET_ALL_QUEUES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRotas: async ({ commit }) => {
    try {
      const response = await operadorHttpService.getRotas()
      commit(GET_ALL_ROUTES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarDepartamentos: async ({ commit }) => {
    try {
      const response = await operadorHttpService.getDepartamentos()
      commit(GET_ALL_DEPARTAMENTOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarOperadoresMonitor: async ({ commit }) => {
    try {
      const response = await operadorHttpService.getOperadoresMonitor()
      commit(GET_OPERADORES_MONITOR, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposDeRotas: async ({ commit }) => {
    try {
      const response = await operadorHttpService.getGruposDeRotas()
      commit(LISTAR_GRUPOS_DE_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
